import React, { useState, useRef, useEffect } from 'react'
import NavItem from './navItem'
import useOutsideClick from 'component/OutsideClickHook'

const NavSubList = ({ title, ulClass, id, subItems, navToggle }) => {
	const [active, setActive] = useState(false)
	const [isMobile, setIsMobile] = useState(null)
	const buttonRef = useRef(null)
	const listRef = useRef(null)

	const handleResize = () => {
		setIsMobile(window.innerWidth <= 1199)
	}

	const toggleSubnav = () => {
		setActive(!active)
	}

	useOutsideClick([buttonRef, listRef], () => {
		setActive(false)
	})

	useEffect(() => {
		setIsMobile(window.innerWidth <= 1199)
		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return (
		<>
			<button
				className={`nav_sublistTitle ${active && 'active'}`}
				onClick={() => toggleSubnav()}
				ref={buttonRef}
			>
				{title}
			</button>
			<ul
				className={`nav_subList ${active && 'active'} ${ulClass}`}
				key={id}
				id={id}
				ref={listRef}
				onMouseLeave={() => {
					if (!isMobile) return setActive(false)
				}}
			>
				{subItems.map((subitem) => (
					<li
						className="nav_subitem ignore-react-onclickoutside"
						key={subitem.id}
					>
						<NavItem
							id={subitem.id}
							type={subitem.type}
							link={subitem.link}
							title={subitem.title}
							subItems={subitem.subItems}
							linkText={subitem.linkText}
							content={subitem.content}
							product={subitem.product}
							spanText={subitem.spanText}
							className={'ignore-react-onclickoutside'}
							navToggle={navToggle}
						/>
					</li>
				))}
			</ul>
		</>
	)
}

export default NavSubList
